import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MaterialModule } from "app/material.module";
import { SharedModule } from "app/shared/shared.module";
import { WebcamModule } from "ngx-webcam";
import { ConfigurationRoutingModule } from "./configuration-routing.module";
import { HospitalManagerConfigurationComponent } from "./hospital-manager-configuration/hospital-manager-configuration.component";
import { EmailConfigurationComponent } from "./email-configuration/email-configuration.component";
import { SearchDashboardConfigComponent } from "./hospital-manager-configuration/search-dashboard-config/search-dashboard-config.component";
import { SearchTimeConfigComponent } from "./hospital-manager-configuration/search-time-config/search-time-config.component";
import { SearchEmailConfigComponent } from "./email-configuration/search-email-config/search-email-config.component";
import { patientBillingConfigurationComponent } from "./patient-billing-configuration/patient-billing-configuration.component";
import { SearchBillingConfigMasterComponent } from "./search-billing-config-master/search-billing-config-master.component";
import { SmsConfigurationComponent } from './sms-configuration/sms-configuration.component';
import { InventoryConfigurationComponent } from './inventory-configuration/inventory-configuration.component';

@NgModule({
  declarations: [
    HospitalManagerConfigurationComponent,
    EmailConfigurationComponent,
    SearchDashboardConfigComponent,
    SearchTimeConfigComponent,
    SearchEmailConfigComponent,
    patientBillingConfigurationComponent,
    SearchBillingConfigMasterComponent,
  
    SmsConfigurationComponent,
   
    InventoryConfigurationComponent,
  ],
  imports: [
    WebcamModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    MatFormFieldModule,
    ConfigurationRoutingModule,
  ],
})
export class ConfigurationModule {}
